export { Body, SmallBody, ButtonText, TypographyCaption, FontWeight, Span } from './Text'
export { Heading, SubHeading, SmallHeading, headingFontSize } from './Heading'
